@if (visible) {
    <div class="m-galleria">
        <div class="m-galleria-actions p-16">
            <app-icon-button
                class="m-btn m-btn-square"
                (click)="download()"
                fill="white"
                icon="download"
            >
            </app-icon-button>
            <!-- <app-icon-button icon="share"
      class="m-btn m-btn-square"
      fill="white"
      (click)="copyToClipboard()">
    </app-icon-button> -->
            <app-icon-button
                class="m-btn m-btn-square"
                (click)="close()"
                fill="white"
                icon="close"
            >
            </app-icon-button>
        </div>
        <div class="m-galleria-body-wrapper flex align-center">
            <div class="p-16">
                @if (hasPrevious) {
                    <app-icon-button
                        class="m-btn m-btn-square"
                        (click)="previous()"
                        fill="white"
                        icon="gallery-previous"
                    >
                    </app-icon-button>
                }
            </div>
            @if (currentImage) {
                <div class="m-galleria-body">
                    <h3 class="m-galleria-title p-16 text-center">{{ currentImage.title }}</h3>
                    <div class="m-galleria-content">
                        @if (currentImage.previewer === 0) {
                            <!-- The main viewer always shows the original at full resolution, and is the one image
                                 on screen the user is actually waiting for, so it loads eagerly. -->
                            <img
                                [alt]="currentImage.alt"
                                [src]="currentImage.source"
                                decoding="async"
                                loading="eager"
                            />
                        }
                        @if (currentImage.previewer === 1) {
                            <pdf-viewer
                                [show-all]="true"
                                [src]="currentImage.source"
                            ></pdf-viewer>
                        }
                        @if (currentImage.previewer === 2) {
                            <video
                                controls
                                preload="metadata"
                            >
                                <source
                                    [src]="currentImage.source"
                                    type="video/mp4"
                                />
                            </video>
                        }
                    </div>
                </div>
            }
            <div class="p-16">
                @if (hasNext) {
                    <app-icon-button
                        class="m-btn m-btn-square"
                        (click)="next()"
                        fill="white"
                        icon="gallery-next"
                    >
                    </app-icon-button>
                }
            </div>
        </div>
        @if (navigator) {
            <div class="m-galleria-navigator p-16">
                @for (image of navigatorImages; track image) {
                    <div
                        class="m-galleria-navigator-item flex flex-column"
                        (click)="navigateToImage(image)"
                    >
                        @if (image) {
                            <img
                                [alt]="image.alt"
                                [src]="image.previewImageSrc"
                                decoding="async"
                                loading="lazy"
                            />
                        }
                        <span class="m-galleria-navigator-title mt-8">{{ image.title }}</span>
                    </div>
                }
            </div>
        }
    </div>
}
